export class Page<T> {
  constructor(
    public readonly pageNumber: number,
    public readonly size: number,
    public readonly totalSize: number,
    public readonly entries: T[],
  ) {}

  public static createWith<T>(entities: T[]): Page<T> {
    return new Page(1, entities.length, entities.length, entities);
  }
}
